import React from 'react';
import 'AppSrc/core/style/components/tables/vf-table.css';
import {
  getTimingTextForValue,
  getNetworkTextForValue,
  getDateDisplay,
  getRowItem,
  getCrqListRowId,
  getCrqListRowKey,
  getStageNameForStatus,
} from 'AppSrc/core/crq/crq-table-utils';
import PropTypes from 'prop-types';
import { getArraySortedWithDirectionByProperty } from 'AppSrc/core/utility-functions/sort-functions';
import { ListTable } from 'AppSrc/core/components/tables/list-table';
import { useHistory } from 'react-router';

const MAX_ROWS = 10;

const columns = [
  { id: 'startDate', name: 'Start Date', sortable: false },
  { id: 'crqId', name: 'CRQ ID', sortable: false },
  { id: 'network', name: 'Network', sortable: false },
  { id: 'timing', name: 'SLA', sortable: false },
  { id: 'coordinatorName', name: 'Coordinator', sortable: false },
  // { id: 'peerReviewerName', name: 'Peer', sortable: false },
  { id: 'stage', name: 'Stage', sortable: false },
];

const getRowForCrq = (crq, index) => {
  const {
    start_date: startDate,
    id: crqId,
    network,
    timing,
    coordinator_name: coordinatorName,
    // peer_reviewer_name: peerReviewerName,
    status,
  } = crq;
  // formating date
  const startDateDisplay = getDateDisplay(startDate);
  // Look up text values for id fields
  const networkText = getNetworkTextForValue(network);
  const timingText = getTimingTextForValue(network, `${timing}`);
  const stage = getStageNameForStatus(status, network);

  // create the array of cells
  const cells = [
    getRowItem({ columnId: 'startDate', displayText: startDateDisplay }),
    getRowItem({ columnId: 'crqId', displayText: crqId }),
    getRowItem({ columnId: 'network', displayText: networkText }),
    getRowItem({ columnId: 'timing', displayText: timingText }),
    getRowItem({ columnId: 'coordinatorName', displayText: coordinatorName }),
    // getRowItem({ columnId: 'peerReviewerName', displayText: peerReviewerName }),
    getRowItem({
      columnId: 'stage',
      displayText: stage,
      withChevron: true,
    }),
  ];
  const rowId = getCrqListRowId(network, crqId);
  const rowKey = getCrqListRowKey(crqId, index);
  return ({
    id: rowId,
    key: rowKey,
    cells,
  });
};

const sortAndTruncateList = (crqList) => {
  const sortedList = getArraySortedWithDirectionByProperty({
    array: crqList,
    propKey: 'start_date',
    sortDescending: false,
    nullsLast: true,
  });
  return sortedList.slice(0, MAX_ROWS);
};

const RequestorRecentCrqTable = ({ crqList }) => {
  const sortedList = sortAndTruncateList(crqList); // todo sort and truncate
  const rows = sortedList.map(getRowForCrq);
  const history = useHistory();
  return (
    <div className="crq-table">
      <ListTable
        className="crq-list-table"
        columns={columns}
        rows={rows}
        onClickRow={(rowId) => history.push(`/crq/${rowId}`)} // rowId is E.G 'mobile/CRQ-000001'
        noResultsMessage="No recent CRQs"
      />
    </div>
  );
};

RequestorRecentCrqTable.propTypes = {
  crqList: PropTypes.arrayOf(PropTypes.object),
};

export { RequestorRecentCrqTable };
